module.exports = __webpack_public_path__ + "img/file_green.0c3a1d54.png";